import React, {FC, useEffect, useState} from 'react';
import {Input, InputProperties} from '@priority-software/priority-style-react';

export const InputWithInnerState: FC<InputProperties> = props => {
    const [state, setState] = useState<string>('');

    useEffect(() => {
        if (props.value !== undefined) {
            setState(props.value);
        }
    }, [props.value]);

    return (
        <Input
            {...props}
            value={state}
            onChange={event => {
                setState(event.target.value);
                props.onChange(event);
            }}
        />
    );
};
